const campaign_channelList = [
    { key: "EMAIL", name: "Email" },
    { key: "SMS", name: "SMS" },
];

export default campaign_channelList;